import Badge from '../common/Badge';
import { BillingInvoice, InvoiceStatus } from '../../types';

export const STATUS_BADGE: Record<InvoiceStatus | 'overdue', { variant: 'secondary' | 'info' | 'success' | 'danger' | 'warning'; label: string }> = {
  draft: { variant: 'secondary', label: 'Draft' },
  sent: { variant: 'info', label: 'Sent' },
  paid: { variant: 'success', label: 'Paid' },
  cancelled: { variant: 'danger', label: 'Cancelled' },
  overdue: { variant: 'warning', label: 'Overdue' },
};

export const STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'paid', label: 'Paid' },
  { value: 'cancelled', label: 'Cancelled' },
];

// "Overdue" is derived (sent + past due date), not a stored status.
export function displayStatus(invoice: Pick<BillingInvoice, 'status' | 'isOverdue'>): InvoiceStatus | 'overdue' {
  return invoice.isOverdue ? 'overdue' : invoice.status;
}

export function InvoiceStatusBadge({ invoice }: { invoice: Pick<BillingInvoice, 'status' | 'isOverdue'> }) {
  const s = STATUS_BADGE[displayStatus(invoice)];
  return (
    <Badge variant={s.variant} size="sm" rounded>
      {s.label}
    </Badge>
  );
}
